var map = {
	"./Aqua.png": 6532,
	"./Aruba.png": 975,
	"./Axonius.png": 1307,
	"./Check-Point.png": 1851,
	"./Cisco.png": 6427,
	"./CrowdStrike.png": 4143,
	"./Cyberark.png": 1337,
	"./Dell.png": 149,
	"./Forcepoint.png": 8061,
	"./Lenovo.png": 3718,
	"./NetScout.png": 3053,
	"./Oracle.png": 4862,
	"./Pentera.png": 5705,
	"./Proofpoint.png": 3404,
	"./Rubrik.png": 1007,
	"./SentinelOne.png": 5254,
	"./Silverfort.png": 2152,
	"./Tenable.png": 6519,
	"./Veeam.png": 7264,
	"./Zimbra.png": 9681,
	"./corelight.png": 5461,
	"./corsight.png": 6743,
	"./elastic.png": 3283,
	"./entrust.png": 8659,
	"./extrahop.webp": 9359,
	"./f5.png": 5567,
	"./fortinet.png": 9317,
	"./group_ib.png": 7369,
	"./hpe.png": 2907,
	"./huawei.png": 6627,
	"./imperva.jpg": 2762,
	"./infoblox.png": 1727,
	"./juniper.png": 3675,
	"./kaytus.png": 7659,
	"./netapp.png": 698,
	"./paloalto.png": 102,
	"./purestorage.png": 3827,
	"./recordedfuture.png": 449,
	"./sailpoint.png": 21,
	"./sangfor.png": 2252,
	"./solarwinds.png": 828,
	"./sonatype.png": 4705,
	"./sophos.webp": 186,
	"./supermap.png": 2309,
	"./vectra.png": 4481,
	"./vicarius.png": 6464,
	"./vmware.png": 4016,
	"./xfusion.webp": 1622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5739;